import { ApiEndPoints, NetworkManager } from "../network";

export class PHCServices {
  static getAllPhcs  = () => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.phcs,
      // params: { page, pages, limit },
    });
  };

  static gePhcsByTalukId = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getPhcByTalukId + id,
      // data: { ...id },
    });
  };

  static addPhc = (phc) => {
    return NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.phcs,
      data: { ...phc },
    });
  };

  static updatePhc = (id, phc) => {
    return NetworkManager.getInstance().appRequest({
      method: "put",
      url: ApiEndPoints.phcs,
      data: { ...id, ...phc },
    });
  };

  static deletePhc = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "delete",
      url: ApiEndPoints.phcs + "/" + id,
      data: { ...id },
    });
  };
}
